<template>
  <!-- 敏感词提示框 -->
  <aui-modal
    v-model="sensitiveWordsShow"
    show-footer
    :title="$t('prmvc.vc.label.sensitive.words.modal.title')"
    width="410px"
    class="sensitive-words-modal"
  >
    <template>
      <icon-info-solid class="sensitive-aui-svg-size"></icon-info-solid>
      <div class="sensitive-words-modal-title">
        {{$t('prmvc.vc.label.sensitive.words.modal.content')}}
      </div>
      <div v-for="item in showArray" :key="item.label" class="sensitive-words-modal-div">
        <span>{{ item.label }}</span>：<span class="sensitive-words-modal-red">{{ item.value }}</span>
      </div>
    </template>
    <template #footer>
      <aui-button type="primary" @click="handleSubmit()">
        {{ $t("jalor.common.button.ok") }}
      </aui-button>
    </template>
  </aui-modal>
</template>

<script>
import { Modal, Button } from "@aurora/vue";
import { IconInfoSolid } from "@aurora/vue-icon";
export default {
  name: "sensitiveWordsModal",
  components: {
    AuiModal: Modal,
    AuiButton: Button,
    // eslint-disable-next-line
    IconInfoSolid: IconInfoSolid(),
  },
  props: {
    showArray: {
      type: Array,
      default: () => {
        return []
      }
    },
  },
  data() {
    return {
      sensitiveWordsShow: false,
    };
  },
  mounted() {},
  methods: {
    handleSubmit() {
      this.sensitiveWordsShow = false;
    },
  },
};
</script>

<style scoped>
.sensitive-words-modal .sensitive-aui-svg-size {
  fill: #1890ff;
  position: absolute;
  top: -29px;
  font-size: 18px;
}
.sensitive-words-modal .sensitive-words-modal-div {
  margin: 5px 0;
}
.sensitive-words-modal .sensitive-words-modal-red {
  color: #f5222d;
}
.sensitive-words-modal /deep/ .aui-grid-modal__header .aui-grid-modal__title {
  margin-left: 25px;
}
.sensitive-words-modal .sensitive-words-modal-title {
  font-weight: 700;
  font-size: 16px;
}
</style>>